import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import Loader from '../loader';

interface LoadableImageProps {
  src: string;
  alt?: string;
  className?: string;
  loaderSize?: number;
  loading?: boolean;
}

const LoadableImage = ({
  src,
  alt,
  className,
  loaderSize = 50,
  loading
}: LoadableImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const stateFor = useRef<string>();

  useEffect(() => {
    if (src !== stateFor.current) {
      setLoaded(false);
      setError(false);
    }
  }, [src]);

  const onError = () => {
    stateFor.current = src;
    setError(true);
  };

  const onLoad = () => {
    stateFor.current = src;
    setLoaded(true);
  };

  return (
    <div className={clsx('loadable-image-wrapper', className)}>
      <img
        src={src}
        alt={alt}
        className={clsx(
          'loadable-image',
          !error && loaded && 'loadable-image-visible',
          loading && 'loadable-image-loading'
        )}
        onLoad={onLoad}
        onError={onError}
      />
      {((!loaded && !error) || loading) && (
        <Loader color='white' size={loaderSize} useAbsoluteWrapper slowAppear />
      )}
      {error && <h5>Error!</h5>}
    </div>
  );
};

export default LoadableImage;
